import React, { ReactElement } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import ChampFormulaire from './ChampFormulaire';
import { LABEL_COL_MODAL } from '../Dashboard/constantes';

const TITRE_CHAMP_DETAIL = 'Détail' as const;

interface PropsModalDetails {
    afficher: boolean;
    setAfficher: () => void;
    titre: string;
    suggestions: string[];
    detailId: string;
    labelDetail?: string;
}

export function ModalDetails(props: PropsModalDetails): ReactElement {
    return (
        <Modal show={props.afficher} onHide={props.setAfficher}>
            <Modal.Header closeButton>
                <Modal.Title>{props.titre}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <ChampFormulaire
                            id={props.detailId}
                            titre={props.labelDetail ? props.labelDetail : TITRE_CHAMP_DETAIL}
                            isCreatable
                            suggestions={props.suggestions}
                            estPetit
                            labelCol={LABEL_COL_MODAL}
                        />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
